document.addEventListener('DOMContentLoaded', function () {
  var viewer = document.getElementById('policyViewer');
  if (!viewer) return;

  // Sposta il pop-up nel body così si centra bene anche su mobile
  if (viewer.parentNode !== document.body) {
    document.body.appendChild(viewer);
  }

  var box = viewer.querySelector('.policy-viewer-box');
  var titleEl = document.getElementById('viewerTitle');
  var contentEl = document.getElementById('viewerContent');
  var fullLink = document.getElementById('viewerFullLink');
  var closeBtn = viewer.querySelector('.policy-viewer-close');
  var overlay = viewer.querySelector('.policy-viewer-overlay');
  var cards = document.querySelectorAll('.info-card[data-slug]');
  var lastFocus = null;

  function findCard(slug) {
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-slug') === slug) return cards[i];
    }
    return null;
  }

  function openViewer(card, updateHash) {
    var slug = card.getAttribute('data-slug');
    var tpl = document.getElementById('policy-tpl-' + slug);
    if (!tpl) return;

    var titleNode = card.querySelector('.info-card-title');
    titleEl.textContent = titleNode ? titleNode.textContent.trim() : '';
    contentEl.innerHTML = tpl.innerHTML;

    var href = card.getAttribute('href');
    if (href && href !== '#') {
      fullLink.setAttribute('href', href);
      fullLink.hidden = false;
    } else {
      fullLink.hidden = true;
    }

    lastFocus = document.activeElement;
    viewer.classList.add('is-active');
    viewer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    box.scrollTop = 0;
    if (closeBtn) closeBtn.focus();

    if (updateHash && window.history && history.replaceState) {
      history.replaceState(null, '', '#' + slug);
    }
  }

  function closeViewer() {
    if (!viewer.classList.contains('is-active')) return;
    viewer.classList.remove('is-active');
    viewer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (window.history && history.replaceState) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      e.preventDefault();
      openViewer(card, true);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeViewer);
  if (overlay) overlay.addEventListener('click', closeViewer);

  document.addEventListener('keydown', function (e) {
    if (!viewer.classList.contains('is-active')) return;
    if (e.key === 'Escape') {
      closeViewer();
      return;
    }
    if (e.key === 'Tab') {
      var focusables = viewer.querySelectorAll('a[href], button:not([disabled])');
      var visible = [];
      for (var i = 0; i < focusables.length; i++) {
        if (!focusables[i].hidden) visible.push(focusables[i]);
      }
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Link diretto, es. /pages/informative#spedizioni
  function openFromHash() {
    var slug = window.location.hash.replace('#', '');
    if (!slug) return;
    var card = findCard(slug);
    if (card) openViewer(card, false);
  }
  openFromHash();
  window.addEventListener('hashchange', function () {
    var slug = window.location.hash.replace('#', '');
    if (!slug) {
      if (viewer.classList.contains('is-active')) closeViewer();
      return;
    }
    var card = findCard(slug);
    if (card) openViewer(card, false);
  });
});